import PropTypes from 'prop-types';
import { useState } from 'react';

import Contents from './Contents';
import trySubmitZip from './trySubmitZip';
import Modal from '../../Modal';
import { localeType } from '../CrossingLocaleBanner';
import { connectLocation } from '../LocationConnectors';

const pickSelectedLocale = (availableLocales, userLocale) =>
  availableLocales.find(l => l.code === userLocale?.code) ||
  availableLocales.find(l => l.code === userLocale?.code?.split('-')[0]) ||
  availableLocales[0];

const LocationModalController = ({
  locationModalOpen,
  closeLocationModal,
  changeUserLocation,
  userLocale,
  showLocale,
  postalRequired,
  availableLocales,
  mismatched,
  showZip,
  isSwitcher,
  locale,
  zip: initialZip,
  address,
}) => {
  // selectedLocale must be one the page offers; translationLocale can be any valid locale
  const [selectedLocale, setSelectedLocale] = useState(() => pickSelectedLocale(availableLocales, userLocale));
  const [translationLocale, setTranslationLocale] = useState(userLocale || locale);
  // only prepopulate the zip if it matches the country
  const [zip, setZip] = useState(() =>
    address?.country_code === selectedLocale?.code?.split('-')[1] ? initialZip : ''
  );
  const [error, setError] = useState(false);

  const selectLocale = l => {
    setSelectedLocale(l);
    setTranslationLocale(l);
  };

  const onSuccess = (loc, zi, addr) => {
    setError(null);
    changeUserLocation({ locale: loc, zip: zi, address: addr });
    closeLocationModal();
  };

  const onSubmit = () => {
    trySubmitZip(selectedLocale, zip, postalRequired || showZip, onSuccess, () => setError(true));
  };

  const shouldShowZip = showZip || postalRequired;
  const open = isSwitcher
    ? locationModalOpen // switcher is toggled by redux
    : mismatched || (postalRequired && !address?.valid); // crossing modal open depends on condition

  return (
    <Modal
      className="location-modal"
      name="Region Selector"
      open={open}
      onClose={closeLocationModal}
      dismissible={isSwitcher}
      size="sm"
    >
      <Contents
        isSwitcher={isSwitcher}
        onSubmit={onSubmit}
        onChangeZip={z => setZip(z?.toUpperCase())}
        showLocale={showLocale}
        showZip={shouldShowZip}
        error={error}
        translationLocale={translationLocale}
        selectedLocale={selectedLocale}
        availableLocales={availableLocales}
        zip={zip}
        setLocaleCode={localeCode => selectLocale(availableLocales.find(l => l.code === localeCode))}
      />
    </Modal>
  );
};

LocationModalController.propTypes = {
  locationModalOpen: PropTypes.bool.isRequired,
  closeLocationModal: PropTypes.func.isRequired,
  changeUserLocation: PropTypes.func.isRequired,
  userLocale: localeType.isRequired,
  showLocale: PropTypes.bool.isRequired,
  showZip: PropTypes.bool.isRequired,
  postalRequired: PropTypes.bool,
  availableLocales: PropTypes.arrayOf(localeType).isRequired,
  mismatched: PropTypes.bool.isRequired,
  isSwitcher: PropTypes.bool,
  locale: localeType.isRequired,
  zip: PropTypes.string.isRequired,
  address: PropTypes.shape({
    valid: PropTypes.bool,
    country_code: PropTypes.string,
  }).isRequired,
};

LocationModalController.defaultProps = {
  isSwitcher: true,
  postalRequired: true,
};

export default connectLocation(LocationModalController);
